module.exports = __webpack_public_path__ + "static/media/w-logo.23f8a41f.png";